<template>
  <div>
    <!-- <v-snackbar v-model="snackbar" :timeout="4000" bottom right :color="color">
                <span>{{message}}</span>
            </v-snackbar> -->
    <v-dialog v-model="loginCardState" persistent transition="dialog-bottom-transition" max-width="700">
      <v-card :loading="loading" class="elevation-1" max-width="700">
        <template slot="progress">
          <v-progress-linear color="primary" height="2" indeterminate></v-progress-linear>
        </template>
        <v-toolbar flat color="transparent">
          <v-btn icon @click="changeFormLogin" v-if="authKind != 'login'">
            <v-icon large>mdi-arrow-left</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn icon @click="changeLoginCardState">
            <v-icon large>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout column>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex xs12>
                  <div align="center" class="mt-2">
                    <v-img max-width="280" src="img/aatf_logo.png"> </v-img>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>

        <div v-if="authKind == 'login'">
          <v-form ref="loginForm" v-model="valid" lazy-validation @submit.prevent="login">
            <v-card-text>
              <div class="mb-5">
                <v-alert class="mx-2 mt-2" v-if="snackbar" dense text dismissible :type="alertType">
                  {{ message }}
                </v-alert>
                <div><b>{{ $t("emailMessage") }}</b></div>
                <v-text-field outlined dense v-model="email" :rules="emailRules" prepend-inner-icon="mdi-email-outline"
                  required class="background login_field"></v-text-field>
                <div class="mt-5"><b>Password</b></div>
                <v-text-field outlined dense v-model="password" prepend-inner-icon="mdi-lock-outline"
                  :rules="inputRules" type="password" class="background login_field "></v-text-field>
                <v-btn depressed block large color="primary" :disabled="!valid" type="submit" :loading="loading"
                  class="text-none mt-7">
                  {{ $t("loginMessage") }}
                  <v-icon right>mdi-login</v-icon>
                </v-btn>
                <v-btn depressed block large color="secondary" @click="changeForm" class="text-none mt-4 white--text">
                  {{ $t("createAccountMessage") }}
                  <v-icon right>mdi-account-plus</v-icon>
                </v-btn>
                <v-btn class="primary--text text-none mt-4" text block large @click="changeFormPassword">
                  {{ $t("forgotPasswordMessage") }}
                </v-btn>
              </div>
            </v-card-text>
          </v-form>
        </div>
        <div v-if="authKind == 'create'">
          <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="create">
            <v-card-text>
              <v-alert class="mx-2 mt-2" v-if="snackbar" dense text dismissible :type="alertType">
                {{ message }}
              </v-alert>
              <div class="my-5">
                <div><b>{{ $t("firstNameMessage") }}</b><span class="red--text">*</span></div>
                <v-text-field outlined dense v-model="userData.f_name" :rules="inputRules"
                  prepend-inner-icon="mdi-account-outline" class="background login_field"></v-text-field>
                <div class="mt-5"><b>{{ $t("middleNameMessage") }}</b><span class="red--text">*</span></div>
                <v-text-field outlined dense v-model="userData.m_name" prepend-inner-icon="mdi-account-outline"
                  class="background login_field"></v-text-field>
                <div class="mt-5"><b>{{ $t("lastNameMessage") }}</b><span class="red--text">*</span></div>
                <v-text-field outlined dense v-model="userData.l_name" :rules="inputRules"
                  prepend-inner-icon="mdi-account-outline" class="background login_field"></v-text-field>
                <div class="mt-5"><b>{{ $t("phoneNumberMessage") }}</b><span class="red--text">*</span></div>
                <v-text-field outlined dense v-model="userData.phone_number" :rules="phoneNumberRules"
                  prepend-inner-icon="mdi-phone" class="background login_field"></v-text-field>
                <div class="mt-5"><b>{{ $t("emailMessage") }}</b><span class="red--text">*</span></div>
                <v-text-field outlined dense v-model="userData.email" :rules="emailRules"
                  prepend-inner-icon="mdi-email-outline" required class="background login_field"></v-text-field>
                <div class="mt-5"><b>{{ $t("passwordMessage") }}</b><span class="red--text">*</span></div>
                <div class="passwordContainer d-flex ">
                  <v-text-field outlined dense v-model="userData.password" :rules="passwordRules" type="password"
                    id="inputPassword" prepend-inner-icon="mdi-lock-outline"
                    class="background login_field"></v-text-field>
                  <a @click="togglePasswordVisibility()"><v-icon large color="green darken-2">
                      {{ passwordVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
                    </v-icon></a>
                </div>
                <div class="mt-5"><b>{{ $t("confirmPasswordMessage") }}</b><span class="red--text">*</span></div>
                <div class="passwordContainer d-flex ">
                  <v-text-field outlined dense v-model="confirmPassword" :rules="passwordConfirmRules" type="password"
                    id="inputConfirmPassword" prepend-inner-icon="mdi-lock-outline"
                    class="background login_field"></v-text-field>
                  <a @click="togglePasswordConfirmVisibility()"><v-icon large color="green darken-2">
                      {{ confirmPasswordVisible ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}
                    </v-icon></a>
                </div>
                <v-btn depressed block large color="primary" :disabled="!valid" type="submit" :loading="loading"
                  class="text-none mt-7">
                  {{ $t("createMessage") }}
                  <v-icon right>mdi-account-plus-outline</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-form>
        </div>
        <div v-if="authKind == 'password'">
          <v-form ref="passwordForm" v-model="valid" lazy-validation @submit.prevent="changePassword">
            <v-card-text>
              <div class="my-5">
                <v-text-field outlined dense v-model="userData.email" :rules="emailRules"
                  prepend-inner-icon="mdi-email-outline" label="E-mail" required class="background login_field">
                </v-text-field>
                <v-btn depressed block large color="primary" :disabled="!valid" type="submit"
                  :loading="loading" class="text-none mt-7">
                  {{ $t("sendLinkMessage") }}
                  <v-icon right>mdi-login</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-form>
        </div>
        <div v-if="authKind == 'confirmOTP'">
          <v-form ref="OTPForm" v-model="valid" lazy-validation @submit.prevent="confirmOTP">
            <v-card-text>
              <div class="my-5">
                <v-text-field outlined dense v-model="OTP" :rules="OTPRules" prepend-inner-icon="mdi-counter"
                  label="OTP" required class="background login_field">
                </v-text-field>
                <v-btn depressed block large color="primary" :disabled="!valid" type="submit" :loading="loading"
                  class="text-none mt-7">
                  {{ $t("confirmOTPMessage") }}
                  <v-icon right>mdi-login</v-icon>
                </v-btn>
              </div>
            </v-card-text>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import apiCall from "@/utils/api";
import { AUTH_OTP } from "@/store/actions/auth";
import { USER_REQUEST } from "@/store/actions/user";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "AuthPopUp",

  data() {
    const me = this
    return {
      passwordVisible: false,
      confirmPasswordVisible: false,
      alertType: "",
      authKind: "login",
      snackbar: false,
      message: "",
      color: "",
      loading: false,
      valid: true,
      userId: null,
      confirmPassword: "",

      passwordConfirmRules: [
        (v) => !!v || this.$t("passwordConfirmIsRequiredMsg"),
        (v) => v === this.userData.password || this.$t("passwordsDoNotMatchMsg"),
      ],


      inputRules: [(v) => !!v || this.$t("inputIsRequiredMessage")],

      OTP: "",
      OTPRules: [
        v => !!v || "OTP is required",
        v => (v && v.length === 6) || "OTP must be 6 characters long",
        v => /^[0-9]*$/.test(v) || "OTP must contain only numbers"
      ],

      phoneNumberRules: [
        (v) => !!v || this.$t("phoneNumberIsRequiredMsg"),
        (v) => /^\d+$/.test(v) || this.$t("mustBeAnIntegerMsg"),
        (v) => (v && v.length >= 10) || this.$t("minimum10DigitsMsg"),
      ],

      password: "",
      passwordRules: [
        (v) => !!v || this.$t("passwordIsRequiredMsg"),
        (v) => (v && v.length >= 12) || this.$t("minimum12CharactersMsg"),
        (v) =>
          /(?=.*[A-Z])/.test(v) || this.$t("mustHaveAtLeastOneUppercaseCharacterMsg"),
        (v) => /(?=.*\d)/.test(v) || this.$t("mustHaveAtLeastOneNumberMsg"),
        (v) =>
          /([!@#$%.])/.test(v) ||
          this.$t("mustHaveAtLeastOneSpecialCharacterMsg"),
      ],
      email: "",
      emailRules: [
        (v) => !!v || this.$t("emailIsRequiredMsg"),
        (v) => (!!v && /.+@.+/.test(v)) || this.$t("emailMustBeValidMsg"),
      ],
      userData: {
        f_name: null,
        m_name: null,
        l_name: null,
        phone_number: null,
        email: null,
        password: null,
      },
    };
  },

  methods: {
    ...mapActions(["changeLoginCardState"]),
    reset() {
      this.$refs.form.reset();
    },
    login: function () {
      if (this.$refs.loginForm.validate()) {
        this.loading = true;
        apiCall({
          method: "POST",
          url: "/api/login",
          data: { email: this.email, password: this.password },
        })
          .then((response) => {
            this.userId = response.userId;
            this.loading = false;
            this.authKind = "confirmOTP";
            this.message = this.$t("inputOTPMsg");
            this.snackbar = true;
            this.alertType = "info";
          })
          .catch(() => {
            this.message = this.$t("invalidCredentialsMsg");
            this.loading = false;
            this.snackbar = true;
            this.alertType = this.$t("loginErrorMsg");
          });
      }
    },
    togglePasswordVisibility() {
      const passwordField = document.getElementById("inputPassword");
      this.passwordVisible = !this.passwordVisible;
      passwordField.type = this.passwordVisible ? "text" : "password";
    },
    togglePasswordConfirmVisibility() {
      const confirmPasswordField = document.getElementById("inputConfirmPassword");
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
      confirmPasswordField.type = this.confirmPasswordVisible ? "text" : "password";
    },
    goToInterests() {
      this.$router.push("/interests");
    },
    confirmOTP: function () {
      if (this.$refs.OTPForm.validate()) {
        this.loading = true;
        const { OTP, userId } = this;
        this.$store
          .dispatch(AUTH_OTP, { OTP, userId })
          .then((response) => {
            this.OTP = "";
            this.$store.dispatch(USER_REQUEST);
            this.$store.dispatch("changeLoginCardState");
            this.loading = false;
            this.$router.push("/redirector");
            this.authKind = "login";
          })
          .catch((response) => {
            this.message = this.$t("invalidOTPMsg");
            this.loading = false;
            this.snackbar = true;
            this.alertType = "error";
          });
      }
    },
    changePassword() {
      if (this.$refs.passwordForm.validate()) {
        this.loading = true;
        apiCall({
          url: "/api/reset-password",
          data: this.userData,
          method: "POST",
        })
          .then((resp) => {
            this.message = "We've sent you a reset link via email.";
            this.color = "success";
            this.loading = false;
            this.snackbar = true;
            this.authKind = "login";
            this.alertType = "success";
          })
          .catch((error) => {
            this.message = "Account does not exist";
            this.loading = false;
            this.snackbar = true;
            this.alertType = "error";
          });
      }
    },
    create() {
      if (this.$refs.form.validate()) {
        if (this.userData.password !== this.confirmPassword) {
          this.message = "Passwords do not match";
          this.color = "error";
          this.snackbar = true;
          this.alertType = "error";
        } else {
          this.loading = true;
          apiCall({ url: "/api/register", data: this.userData, method: "POST" })
            .then((resp) => {
              if (resp.status === 409) {
                this.message = resp.message;
                this.color = "error";
                this.loading = false;
                this.snackbar = true;
                this.alertType = "error";
              } else {
                this.message = "Registration successful. Please log in to continue.";
                this.color = "success";
                this.loading = false;
                this.snackbar = true;
                this.authKind = "login"; // Redirect to login form
                this.alertType = "success";
              }
            })
            .catch((error) => {
              console.error(error);
              this.message = "An error occurred; Please try again.";
              this.loading = false;
              this.snackbar = true;
              this.alertType = "error";
            });
        }
      }
    },
    changeForm() {
      this.authKind = "create";
      this.snackbar = false;
    },
    changeFormLogin() {
      this.authKind = "login";
      this.snackbar = false;
    },
    changeFormPassword() {
      this.authKind = "password";
      this.snackbar = false;
    },
  },
  computed: {
    ...mapGetters(["loginCardState", "nationalities", "genders"]),
    ...mapState({
      authLoading: (state) => state.auth.status === "loading",
    }),
  },
};
</script>